import React, { useState, useEffect } from "react";
import apiClient from "../../AppClient";
import { Container, Form, Button, Table, Alert, Spinner } from "react-bootstrap";

const FertilizingDateReport = () => {
  const [reports, setReports] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [nameFilter, setNameFilter] = useState("");

  const fetchReports = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get("/transactions/reports/products-fertilizing-date/");
      setReports(response.data);
      setError(null);
    } catch (error) {
      setError(error.response?.data?.detail || "فشل في جلب تقرير تسميد المنتجات.");
    } finally {
      setLoading(false);
    }
  };

  const filteredReports = reports.filter((report) =>
    nameFilter ? report.name.toLowerCase().includes(nameFilter.toLowerCase()) : true
  );

  useEffect(() => {
    fetchReports();
  }, []);

  return (
    <Container style={{ 
      direction: "rtl", 
      textAlign: "right", 
      padding: "20px", 
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      color: "black", 
      backgroundColor: "white" 
    }}>
      <h1 style={{ color: "darkgreen", marginBottom: "20px" }}>تقرير تاريخ تسميد المنتجات</h1>

      {/* Filters */}
      <div style={{ display: "flex", marginBottom: "20px", gap: "10px" }}>
        <Form.Control
          type="text"
          placeholder="ترتيب حسب اسم المنتج"
          value={nameFilter}
          onChange={(e) => setNameFilter(e.target.value)}
          style={{ maxWidth: "250px" }}
        />
        <Button 
          variant="outline-secondary" 
          onClick={() => setNameFilter("")}
          style={{ border: "1px solid darkgreen", color: "darkgreen" }}
        >
          مسح الترتيب
        </Button>
      </div>

      {/* Error Message */}
      {error && <Alert variant="danger">{error}</Alert>}

      {/* Loading Spinner */}
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status" style={{ color: "darkgreen" }}>
            <span className="visually-hidden">جاري التحميل...</span>
          </Spinner>
        </div>
      ) : (
        /* Report Table */
        <Table hover responsive>
          <thead style={{ backgroundColor: "darkgreen", color: "white" }}>
            <tr>
              <th>#</th>
              <th>اسم المنتج</th>
              <th>التاريخ (يوم)</th>
            </tr>
          </thead>
          <tbody>
            {filteredReports.map((report, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{report.name}</td>
                <td>{report.date}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default FertilizingDateReport;
